export const text = [
    {
        summary: 'The Grand',
        details: [
            {
                summary: 'A Creek',
                details: [
                    {
                        summary: 'A Gully',
                        details: [
                            "Dry as a bone, but not for long",
                        ],
                    },
                    {
                        summary: 'A Ravine',
                        details: [
                            "Bursting full of life and energy",
                        ],
                    },
                    {
                        summary: 'A wash',
                        details: [
                            "Trickles down and I can barely feel it",
                        ],
                    },
                ],
            },
            {
                summary: 'A Delta',
                details: [
                    {
                        summary: 'Meandering',
                        details: [
                            "A slow journey"
                        ],
                    },
                    {
                        summary: 'Anastomosing',
                        details: [
                            "None of that silly business",
                        ],
                    },
                    {
                        summary: 'Braided',
                        details: [
                            "Look at that lateral movement"
                        ],
                    },
                ],
            }
        ]
    }
];

export default text;